import React from 'react';
export function HookSection() {
  return <section className="bg-gradient-to-b from-[#0a0a0a] via-[#120000] to-[#0a0a0a] py-[34px] px-5" data-id="element-96">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-97">
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-3 text-left" data-id="element-98">
          Hay una conversación que ningún hombre quiere tener. Ni con su médico.
          Ni con sus amigos. Ni siquiera consigo mismo. Pero esa conversación
          vive en tu cabeza{' '}
          <strong className="text-brand-white font-semibold" data-id="element-99">
            cada vez que la intimidad se acerca...
          </strong>
        </p>
        <div className="border-l-[4px] border-brand-red bg-[#150000] py-3 px-[20px] my-[16px] rounded-r-[8px]" data-id="element-100">
          <p className="text-[1rem] italic text-[#ddd] leading-[1.6]" data-id="element-101">
            "¿Y si termino antes de tiempo otra vez?"
            <br data-id="element-102" />
            "¿Qué pensará ella si no puedo controlarme?"
            <br data-id="element-103" />
            "Estoy perdiendo la confianza que alguna vez tuve."
          </p>
        </div>
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-3 text-left" data-id="element-104">
          Si alguna de esas frases resonó en tu mente, no estás solo. Más del{' '}
          <strong className="text-brand-white font-semibold" data-id="element-105">
            31% de los hombres
          </strong>{' '}
          enfrenta este problema en silencio. El error está en creer que es un
          defecto permanente.
          <strong className="text-brand-white font-semibold" data-id="element-106">
            No lo es.
          </strong>{' '}
          Es un problema de entrenamiento — y todo problema de entrenamiento
          tiene solución.
        </p>
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-0 text-left" data-id="element-107">
          El{' '}
          <strong className="text-brand-white font-semibold" data-id="element-108">
            Sistema El Código del Control
          </strong>{' '}
          es el método científico que entrena el músculo exacto que controla tu
          rendimiento, elimina la ansiedad que lo sabotea, y te convierte —
          <strong className="text-brand-white font-semibold" data-id="element-109">en 30 días</strong>{' '}
          — en un hombre completamente diferente dentro y fuera de la cama.
        </p>
      </div>
    </section>;
}